import { axiosInstance } from './httpClient';
import { API } from './env';

function authHeaders() {
  const userInfo = JSON.parse(localStorage.getItem('user'));
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + userInfo.token,
  };
}

export default class AiApi {
  static listConversations() {
    return axiosInstance.get(`${API}/admin/ai/conversations`, { headers: authHeaders() });
  }

  static createConversation() {
    return axiosInstance.post(`${API}/admin/ai/conversations`, {}, { headers: authHeaders() });
  }

  static getConversation(id) {
    return axiosInstance.get(`${API}/admin/ai/conversations/${id}`, { headers: authHeaders() });
  }

  static deleteConversation(id) {
    return axiosInstance.delete(`${API}/admin/ai/conversations/${id}`, { headers: authHeaders() });
  }

  static chat(id, message) {
    return axiosInstance.post(`${API}/admin/ai/conversations/${id}/chat`, { message }, { headers: authHeaders() });
  }
}
